import { isGeneratedListTrpcProcedurePath } from "@/utils/trpc/generated-list-route";
import { isInteractiveTrpcRequest } from "@/utils/trpc/request-priority";

// PDF renders return large, finite payloads that must be fully consumed before the
// mutation resolves; the JSONL link may close its fetch as soon as its promise
// chunk settles, which leaves Chromium reporting a successful render as aborted.
const directTrpcProcedurePaths = new Set([
  "documentInstance.issue",
  "documentInstance.uploadSignedArtifact",
  "finance.createManualDocument",
  "finance.exportRows",
  "finance.renderAgencyInvoiceDocumentTemplate",
  "finance.renderInvoiceDocumentTemplate",
  "finance.renderSettlementReceiptTemplate",
  "finance.updateDocument",
  "placement.listRequirements",
]);

export type TrpcHttpTransport = "direct" | "generated-list" | "search" | "stream";

export function getTrpcHttpTransport({
  context,
  path,
}: {
  context: Record<string, unknown> | undefined;
  path: string;
}): TrpcHttpTransport {
  // Search must not cold-load the application-wide procedure registry or share
  // a batch/abort lifecycle with unrelated background queries.
  if (path === "search.organization" || path === "search.agency") {
    return "search";
  }

  if (
    isInteractiveTrpcRequest(context)
    && isGeneratedListTrpcProcedurePath(path)
  ) {
    return "generated-list";
  }

  if (
    isInteractiveTrpcRequest(context)
    || directTrpcProcedurePaths.has(path)
  ) {
    return "direct";
  }

  return "stream";
}
